import { ChangeDetectionStrategy, Component, type Type } from '@angular/core';
import { SchoolMapItemPopupContentComponent } from './components/school-map-item-popup-content/school-map-item-popup-content.component';
import { SchoolMapItem } from './definitions/school-map-item';
import { MapWithSidebarModule } from '@ui/shared/feature-map';
import { SchoolMapDetailsComponent } from './components/school-map-item-details/school-map-item-details.component';
import { AsyncPipe } from '@angular/common';
import { SchoolMapFiltersComponent } from './components/school-map-filters/school-map-filters.component';
import { BaseAppComponent } from '@ui/shared/feature-config';
import type { MapItemComponent } from '@ui/shared/util-map';
import {
    SchoolMapItemFilteredMeasuresComponent,
} from './components/school-map-item-filtered-measures/school-map-item-filtered-measures.component';

@Component({
    selector: 'ui-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MapWithSidebarModule,
        AsyncPipe,
        SchoolMapDetailsComponent,
        SchoolMapFiltersComponent,
    ],
})
export class AppComponent extends BaseAppComponent<SchoolMapItem> {

    public listCustomContentComponentType: Type<MapItemComponent<SchoolMapItem>> = SchoolMapItemFilteredMeasuresComponent;

    constructor() {
        super(SchoolMapItemPopupContentComponent);
    }
}
